<script>
const date = new Date();

let year = date.getFullYear();
</script>



<footer>
    <div>
        Copyright {year} Dot.tech Devs
    </div>
</footer>

<style>
    footer{
        width: 100%;
        padding: 40px 5px;
        text-align: center;
    }
    div{
        text-align: center;
        font-size: 12px;
        color: #ff634780;
        padding: 10px;
        width: 300px;
        margin: 0 auto;
        border-top: 2px solid #ff634780;
    }
</style>